<template>
  <div>
    <toastification-loading-content ref="loadingToast" />
    <toastification-progress-content ref="progressToast" />

    <b-row class="pt-2 pb-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col>
    </b-row>

    <!-- Filters -->
    <filter-modal
      @action="buildFilters()"
      @clear="clearSearchFilters()"
    >
      <template v-slot:main-filters>
        <filters
          :name-filter.sync="nameFilter"
          :unit-filter.sync="unitFilter"
          :unit-options="unitOptions"
          :start-datetime.sync="startDatetimeFilter"
          :end-datetime.sync="endDatetimeFilter"
        />
      </template>
    </filter-modal>

    <!-- Table Container Card -->
    <b-card class="m-2" no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="text-capitalize">{{ $t("table.show") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label class="text-capitalize">{{ $t("table.entries") }}</label>
          </b-col>

          <!-- Search and Export-->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('table.search')"
              />
              <b-button
                @click="exportExcel()"
                variant="success"
                class="text-capitalize"
                type="button"
                :disabled="buttonExport"
              >
                <feather-icon icon="DownloadCloudIcon" size="15" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- Table-->
      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('no_record_found')"
        :sort-desc.sync="isSortDirDesc"
        @row-selected="onRowSelected"
        select-mode="single"
        selectable
      >
        <template #head()="data">
          <span> {{ $tc(data.label, 1) }}</span>
        </template>
        <template #cell(image)="data">
          <div class="hoverable">
            <b-img
              :src="`${data.item.descriptor}`"
              alt="path Image"
              style="max-height: 120px"
            ></b-img>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">{{
              $t("table.showing", {
                from: dataMeta.from,
                to: dataMeta.to,
                of: dataMeta.of,
              })
            }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="update"
              :perPage="perPage"
            >
            </Pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- Modal -->
    <b-card class="m-2" v-if="selectedObject" no-body>
      <feather-icon
        icon="XIcon"
        class="mr-2 ml-auto mt-2 float-rigth"
        style="cursor: pointer"
        size="30"
        @click="selectedObject = null"
      />
      <div class="mx-2">
        <div class="w-75 mx-auto">
          <div class="row">
            <div class="col-12 mb-2">
              <img class="img-thumbnail" :src="`${selectedObject.media.url}`" alt="" />
            </div>
            <div class="col-6 text-center">
              <img class="img-thumbnail" :src="`${selectedObject.descriptor}`" alt="" />
              <p class="my-0 mt-1">Persona Detectada</p>
            </div>
            <div class="col-6 text-center">
              <img class="img-thumbnail" :src="`${selectedObject.avatar}`" alt="" />
              <p class="my-0 mt-1">Persona Enrolada</p>
            </div>
          </div>
        </div>
        <table class="table table-sm">
          <tr>
            <th>Detección:</th>
            <td>{{ formatDateAssigned(selectedObject.created_at) }}</td>
          </tr>
          <tr>
            <th>Nombre de la instalación:</th>
            <td>{{ selectedObject.unit }}</td>
          </tr>
          <tr>
            <th>Nombre de la persona:</th>
            <td>{{ selectedObject.name }}</td>
          </tr>
          <tr>
            <th>Nombre de la lista:</th>
            <td>{{ selectedObject.listName }}</td>
          </tr>
          <tr>
            <th>Edad:</th>
            <td>{{ selectedObject.age }}</td>
          </tr>
          <tr>
            <th>Genero</th>
            <td>{{ selectedObject.gender }}</td>
          </tr>
          <tr>
            <th>Emoción captada:</th>
            <td>{{ selectedObject.emotion }}</td>
          </tr>
          <tr>
            <th>Uso de mascarilla:</th>
            <td>{{ selectedObject.mask }}</td>
          </tr>
          <tr>
            <th>Calidad de imagen:</th>
            <td>
              <table class="table table-sm">
                <tr>
                  <th>Borrosidad</th>
                  <td>{{ formatPercentages(selectedObject.qualityBlurriness) }}</td>
                </tr>
                <tr>
                  <th>Oscuridad</th>
                  <td>{{ formatPercentages(selectedObject.qualityDark) }}</td>
                </tr>
                <tr>
                  <th>Brillo</th>
                  <td>{{ formatPercentages(selectedObject.qualityLight) }}</td>
                </tr>
                <tr>
                  <th>Saturación</th>
                  <td>{{ formatPercentages(selectedObject.qualitySaturation) }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <th>Puntaje de retrato:</th>
            <td>{{ formatPercentages(selectedObject.score) }}</td>
          </tr>
          <tr>
            <th>Puntaje de similitud:</th>
            <td>{{ formatPercentages(selectedObject.similarity) }}</td>
          </tr>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardGroup,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, onUnmounted, onMounted, computed, watch } from "@vue/composition-api";
import useList from "./useList";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import ToastificationProgressContent from "@core/components/toastification/ToastificationProgressContent.vue";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import Filters from "./Filters";
import Pagination from "@/components/Pagination.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";

export default {
  components: {
    Pagination,
    BCardGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BImg,
    BreadcrumbMenu,
    ToastificationLoadingContent,
    ToastificationProgressContent,
    Filters,
    vSelect,
    FilterModal,
    ButtonFilters,
  },
  setup(_, context) {
    //start pagination
    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const selectedObject = ref(null);
    const buttonExport = ref(false);
    const loadingToast = ref(null);
    const progressToast = ref(null);
    const progress = computed(() => store.getters["facial_recognition/getProgress"]);
    const error = computed(() => store.getters["facial_recognition/getError"]);
    const url = computed(() => store.getters["facial_recognition/getUrl"]);
    store.dispatch("grid/findDownloadNotification", "facial-recognition").then((data) => {
      if (data.length > 0) {
        buttonExport.value = true;
        progressToast.value.show("Descarga", "Generando archivo...", "secondary");
      }
    });
    const toast = useToast();
    const exportExcel = () => {
      buttonExport.value = true;
      store.dispatch("facial_recognition/resetProgress");
      progressToast.value.show("Descarga", "Generando archivo...", "secondary");
      store
        .dispatch("facial_recognition/getAll", {
          q: searchQuery.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          name: nameFilter.value,
          unit: unitFilter.value,
          startDatetime: startDatetimeFilter.value,
          endDatetime: endDatetimeFilter.value,
          personId: personFilter.value,
          action: "export",
        })
        .then((response) => {
          store.dispatch(
            "facial_recognition/setExportFacialRecognition",
            response.data.jobId
          );
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error exportando la información",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          buttonExport.value = false;
          progressToast.value.close();
        });
    };
    watch([progress], () => {
      progressToast.value.updateProgress(progress.value);
    });
    watch([error], () => {
      toast({
        component: ToastificationContent,
        props: {
          title: error,
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
      buttonExport.value = false;
      progressToast.value.close();
    });
    watch([url], () => {
      if (url.value) {
        const link = document.createElement("a");
        link.href = url.value;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        buttonExport.value = false;
        progressToast.value.close();
      }
    });

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      nameFilter,
      personFilter,
      unitFilter,
      unitOptions,
      startDatetimeFilter,
      endDatetimeFilter,
      filtersCount,
      buildFilters,
      clearSearchFilters,
    } = useList();

    onMounted(() => {
      window.Echo.private(`facial-recognition`).listen(".create", (data) => {
        refetchData();
      });
    });
    onUnmounted(() => {
      window.Echo.leave(`facial-recognition`);
    });
    const onRowSelected = (item) => {
      selectedObject.value = item[0];
    };
    const formatPercentages = (num) => {
      return `${(parseFloat(num) * 100).toFixed(2)} %`;
    };
    return {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      unitOptions,
      nameFilter,
      unitFilter,
      startDatetimeFilter,
      endDatetimeFilter,
      selectedObject,
      onRowSelected,
      formatPercentages,
      exportExcel,
      buttonExport,
      loadingToast,
      progress,
      progressToast,
      update,
      clearSearchFilters,
      filtersCount,
      buildFilters,
    };
  },
};
</script>
